// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"328f2fe2","576":"47c7f5a3"}[chunkId] + ".chunk.css";
};